import styled from 'styled-components'

type StyledProps = {
  $blend: boolean
}

const StyledHeader = styled.header<StyledProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;
  padding: 0 16px;
  box-sizing: border-box;
  position: fixed;
  left: 0;
  right: 0;
  width: 100%;
  top: 0;
  z-index: ${({ theme }) => theme.elevation.fixed};

  .logo {
    display: flex;

    svg {
      height: 36px;
    }
  }

  nav {
    display: none;
    gap: 20px;
    height: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    a {
      display: flex;
      align-items: center;
      font-weight: 500;
      text-decoration: none;
      font-size: 16px;
      transition: 0.2s;
      position: relative;

      svg {
        height: 20px;
        stroke-width: 2.25px;
        margin-left: 4px;
      }

      &.active {
        font-weight: 600;

        &::after {
          content: '';
          position: absolute;
          bottom: -1px;
          left: 0;
          right: 0;
          width: 100%;
          height: 2.5px;
          border-radius: 50rem 50rem 0 0;
        }
      }
    }
  }

  .header-actions {
    display: flex;
    align-items: center;

    .header-btn {
      height: 40px;
      padding: 0 14px;
      border-radius: 8px;
      font-size: 16px;
      font-weight: 500;
      display: flex;
      align-items: center;
      text-decoration: none;
      color: ${({ theme }) => theme.color.gray[900]};
      border: 1px solid ${({ theme }) => theme.color.gray[900]};
      background-color: transparent;
      transition: 0.2s;

      &:hover {
        background-color: ${({ theme }) => theme.color.gray[200]};
      }

      &.signup-btn {
        color: rgb(255, 255, 255);
        border: 1px solid ${({ theme }) => theme.color.gray[900]};
        background-color: ${({ theme }) => theme.color.gray[900]};

        &:hover {
          background-color: ${({ theme }) => theme.color.gray[700]};
        }
      }

      &:not(:last-child) {
        margin-right: 10px;
      }
    }

    .avatar {
      cursor: pointer;
    }
  }

  ${({ $blend, theme }) =>
    !$blend &&
    `
    background-color: ${theme.color.background};
    box-shadow: 0 1px ${theme.color.gray[300]};

    .logo {
      color: ${theme.color.gray[900]};
    }

    nav a {
      color: ${theme.color.gray[500]};

      &:hover {
        color: ${theme.color.gray[700]};
      }

      &.active {
        color: ${theme.color.gray[900]};
    
        &::after {
          background-color: ${theme.color.gray[900]};}
        }
      }
    }
  `}

  ${({ $blend }) =>
    !!$blend &&
    `
    background-color: #041926;
    box-shadow: 0 1px rgb(255, 255, 255, 0.2);

    .logo {
      color: rgb(255, 255, 255, 1);
    }

    nav a {
      color: rgb(255, 255, 255, 0.4);

      &:hover {
        color: rgb(255, 255, 255, 0.8);
      }

      &.active {
        color: rgb(255, 255, 255, 1);
    
        &::after {
          background-color: rgb(255, 255, 255, 1);
        }
      }
    }

    .header-actions {
      .header-btn {
        color: rgb(255, 255, 255, 1);
        border: 1px solid rgb(255, 255, 255, 1);

        &:hover {
          background-color: rgb(255, 255, 255, 0.2);
        }
  
        &.signup-btn {
          color: #041926;
          border: 1px solid rgb(255, 255, 255, 1);
          background-color: rgb(255, 255, 255, 1);
  
          &:hover {
            background-color: rgb(255, 255, 255, 0.8);
          }
        }
      }
    }
  `}

  @media (min-width: 700px) {
    nav {
      display: flex !important;
    }
  }
`

export default StyledHeader
